import { IconBase, type IconProps } from './IconBase';

export function TerminalIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M4 5h16v14H4z" />
      <path d="M8 10l3 2-3 2M13 14h3" />
    </IconBase>
  );
}
